import { render, staticRenderFns } from "./serviceUser.vue?vue&type=template&id=2b6fa3e8&scoped=true"
import script from "./serviceUser.vue?vue&type=script&lang=js"
export * from "./serviceUser.vue?vue&type=script&lang=js"
import style0 from "./serviceUser.vue?vue&type=style&index=0&id=2b6fa3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6fa3e8",
  null
  
)

export default component.exports